(() => {
  //onload
  document.addEventListener('DOMContentLoaded', () => {

    jQuery('select[name="custom_shipping_option"]').on('change', function() {
      var selected = jQuery(this).val();

      if (selected) {
        jQuery.ajax({
          type: 'POST',
          url: '/?wc-ajax=update_order_review',
          data: {
            security: wc_checkout_params.update_order_review_nonce,
            'shipping_method[0]': selected
          },
          success: function(response) {
            jQuery('body').trigger('update_checkout');
          }
        });
      }
    });

    document.addEventListener('click', function (e) {
      const expandBtn = document.getElementById('expand-order-summary');
      const review = document.getElementById('order_review');

      if (expandBtn && review && expandBtn.contains(e.target)) {
        review.classList.toggle('open');

        // Save state
        sessionStorage.setItem('orderReviewOpen', review.classList.contains('open') ? '1' : '0');
      }
    });

    jQuery(document.body).on('updated_checkout', function () {
      const review = document.getElementById('order_review');
      if (review && sessionStorage.getItem('orderReviewOpen') === '1') {
        review.classList.add('open');
      }
    });

    const btnsChangePayment = [
      ...document.querySelectorAll('.qte-payment-method'),
    ];

    if (isNaN(btnsChangePayment.length)) {
      console.error(
        npVars.payment_method_buttons_not_found_string,
      );
      return;
    }

    btnsChangePayment.map((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();

        //add class active to the button
        btnsChangePayment.forEach((b) => {
          b.classList.remove('active');
        });

        btn.classList.add('active');

        const selector = '#payment_method_' + btn.id;

        const paymentMethod = document.querySelector(selector);
        if (!paymentMethod) {
          console.error(npVars.payment_method_not_found_string);
          return;
        }

        paymentMethod.click();
      });
    });

    if (btnsChangePayment.length > 0) {
      btnsChangePayment[0].click(); //click the first button to set the default payment method
    }
  });

  //submit discount code form
  jQuery(document).ready(function ($) {
    const btnDiscount = $('.coupon-button');

    btnDiscount.on('click', function (e) {
      e.preventDefault();

      const inputDiscount = $('#coupon_code');
      const coupon = inputDiscount.val();

      if (!coupon) return;

      // Disable button and show loading state
      btnDiscount.prop('disabled', true).text(npVars.applying_coupon_label);

      $.ajax({
        type: 'POST',
        url: npVars.ajax_url,
        data: {
          action: 'np_coupons',
          nonce: npVars.nonce,
          add_coupon_code: coupon
        },
        success: function (result) {
          // Re-enable button
          btnDiscount.prop('disabled', false).text(npVars.apply_coupon_label);

          inputDiscount.val(''); // Clear the input field

          jQuery('body').trigger('update_checkout');
          refreshCoupons();
        },
        error: function (xhr) {
          btnDiscount.prop('disabled', false).text(npVars.apply_coupon_label);
          $('.woocommerce-notices-wrapper').html('<ul class="woocommerce-error"><li>'+ npVars.something_went_wrong_label + '</li></ul>');

          console.log(xhr);
        },
      });
    });

    // If press [data-remove-coupon] button
    $(document).on('click', '[data-remove-coupon]', function (e) {
      e.preventDefault();

      const coupon_code = $(this).data('remove-coupon');

      var btn = $(this);
      couponMessage(npVars.coupon_removing_string);
      btn.remove();

      jQuery.ajax({
        type: 'POST',
        url: npVars.ajax_url,
        data: {
          action: 'np_coupons',
          nonce: npVars.nonce,
          coupon_code: coupon_code
        },
        success: function (response) {
          jQuery('body').trigger('update_checkout');
          refreshCoupons(false);
        },
        error: function () {
          console.error(npVars.coupons_error_string);
        },
      });

    });
    function couponMessage(message) {
      $('.np-applied-coupons').html(message);
    }

    function refreshCoupons(showLoading = true) {

      if (showLoading)
        couponMessage('<i>'+npVars.coupons_loading_string+'...</i>');

      // If we are on /cart page, we just refresh the page.
      if (window.location.pathname === '/cart/') {
        window.location.reload();
        return;
      }

      jQuery.ajax({
        type: 'POST',
        url: npVars.ajax_url,
        data: {
          action: 'np_coupons',
          nonce: npVars.nonce
        },
        success: function (response) {
          jQuery('.np-applied-coupons').html(response);
        },
        error: function () {
          console.error(npVars.coupons_error_string || 'Error fetching applied coupons');
        }
      });
    }

  });

})();
